function middlewarePipeline(context, middleware, index) {
  let nextMiddleware = middleware[index];
  if (!nextMiddleware) {
    // debugger;
    return context.next;
  }
  return () => {
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);

    nextMiddleware({ context, nextMiddleware: nextPipeline });
  };
}

// Отмена перехода (next(false)) закрывает лоадер: middleware при ошибке загрузки обрывают цепочку,
// и loaderStop не выполняется, а лоадер из loaderStart открыт с manual: true и сам не закроется.
export function createMiddlewareContext(to, from, next, store) {
  return {
    to,
    from,
    next: (...args) => {
      if (args[0] === false && store.loaderStore.show) {
        store.loaderStore.setLoader();
      }
      return next(...args);
    },
    store,
  };
}

export default middlewarePipeline;
